const oneFloor = {
    pdf: 'https://res.cloudinary.com/carronadepark/image/upload/v1611351497/Floor%20Plans/first_floor_1_gaw1v5.jpg',
    images: [
        { 
            id: 0,
            url: 'https://res.cloudinary.com/carronadepark/image/upload/v1611351497/Floor%20Plans/first_floor_1_gaw1v5.jpg',
            alt: 'One Floor Home'
        }
    ],
    bed: 1,
    bath: 1.5,
    sf: 700
};
const twoFloors = {
    pdf: 'https://res.cloudinary.com/carronadepark/image/upload/v1611351495/Floor%20Plans/second_floor_1_rachlw.jpg',
    images: [
        {
            id: 1,
            url: 'https://res.cloudinary.com/carronadepark/image/upload/v1611351497/Floor%20Plans/first_floor_1_gaw1v5.jpg',
            alt: 'First Floor'
        },
        {
            id: 2,
            url: 'https://res.cloudinary.com/carronadepark/image/upload/v1611351495/Floor%20Plans/second_floor_1_rachlw.jpg',
            alt: 'Second Floor'
        }
    ],
    bed: 3,
    bath: 2.5,
    sf: 1400
}

export { oneFloor, twoFloors };